import React, { memo } from 'react';
import { connect } from 'react-redux';

import { getCurrentRolesList } from '../../redux/session/selectors';
import { AppState } from '../../redux/state';
import { getComponentName } from '../../utils/components';

const mapStateToProps = (state: AppState) => ({
  currentRoles: getCurrentRolesList(state),
});

export const withPermissions = ({ whitelist }: PermissionsProps) => (
  Component: React.ComponentType<any>
) => {
  const Enhanced = connect(mapStateToProps)(
    memo(({ currentRoles, ...props }: any) =>
      isWhitelisted(currentRoles, whitelist) ? <Component {...props} /> : null
    )
  );

  Enhanced.displayName = `withPermissions(${getComponentName(Component)})`;

  return Enhanced;
};

export default withPermissions;

export function isWhitelisted(roles: string[], whitelist: string | string[]) {
  if (Array.isArray(whitelist)) {
    return whitelist.some(role => roles.includes(role));
  }

  return roles.includes(whitelist);
}

interface PermissionsProps {
  whitelist: string[] | string;
  currentRoles?: string[];
}
